module.exports = __webpack_public_path__ + "img/inter_throw_mmagnify.d36decc3.svg";